export default {
    sUIApi2: Symbol(),
    sUIApi2Enforcer: Symbol(),
    debounce(f, ms) {

        let timer = null;
        let promise = new Promise((resolve) => {
            resolve([]);
        });

        return function (...args) {
            const onComplete = () => {
                timer = null;
                return f.apply(this, args);
            };

            if (timer) {
                clearTimeout(timer);
            }
            promise = new Promise((resolve) => {
                timer = setTimeout(function () {
                    resolve(onComplete())
                }, ms);
            });

            return promise;
        };
    },
    toastDebounce() {
    },
    keyCodes: {
        windows: {
            "backspace": 8,
            "tab": 9,
            "enter": 13,
            "left arrow": 37,
            "right arrow": 39,
            "delete": 46,
            "period": 190,
            "0": 48,
            "9": 57,
            "num 0": 96,
            "num 9": 105,
            "num period": 110,
            "input busy": 229
        }
    },
    thousandDelimeter: ',',
    accountMask: '0000 0000 0000',
    initialState: () => ({
        feed: {feedInner: null, locale: null},
        accountId: null,
        currentAccount: null,
        accountInfo: new Map(),                   //key such as id.(m/p/s/w).(PW/GW/Rank/...)
        loadingAccountInfo: new Map(),           // in situation when mapAccountInfo hasn't attribute to return to component, becouse it's now loading in other process, we collect a pull of promisses, and when await for them
        loadingAccountId: null
    })
}